class StickyAtc extends HTMLElement {
  connectedCallback() {
    const stickyAtc = this;
    const hideEnd = this.hasAttribute("hide-end");

    const button = this.querySelector(".sticky-atc__button");
    const targetSelector = button?.getAttribute("href");
    const productSection = document.querySelector(targetSelector);

    if (!stickyAtc || !productSection) return;

    let productOutOfView = false;
    let reachedEnd = false;

    const updateReachedEnd = () => {
      const scrollPos = window.scrollY + window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      reachedEnd = hideEnd && scrollPos >= docHeight - 20;
    };

    const updateStickyState = () => {
      if (productOutOfView && !reachedEnd) {
        stickyAtc.classList.add("visible");
      } else {
        stickyAtc.classList.remove("visible");
      }
    };

    const productObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          productOutOfView = !entry.isIntersecting;
          updateStickyState();
        });
      },
      { threshold: 0 },
    );

    productObserver.observe(productSection);

    const handleScroll = () => {
      updateReachedEnd();
      updateStickyState();
    };

    const handleResize = () => {
      updateReachedEnd();
      updateStickyState();
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    updateReachedEnd();
    updateStickyState();
  }
}

customElements.define("sticky-atc", StickyAtc);
